import * as React from 'react';
import { Helmet } from 'react-helmet';
import { Notifs } from 'redux-notifications';
const { connect } = require('react-redux');
const { asyncConnect } = require('redux-connect');
import { IStore } from 'redux/IStore';
import { getLanguageDomainValues } from 'modules/domainvalues';
import { IPreloader } from 'models/preloader';
import { ModalManager } from 'containers';
import 'redux-notifications/lib/styles.css';
const appConfig = require('../../../../config/main');
import { ILanguage } from 'models/common';
import 'moment/locale/sl';
import {
	detectIncompatibleBrowsers,
	getShoppingBasketExpiryDate,
	removeShoppingBasketExpiryDate,
	setShoppingBasketExpiryDate,
} from 'helpers/common';
import { ICart, ICartAction } from 'models/cart/cart';
import { clearShoppingBasket } from 'modules/cart';
import { actions as notifActions } from 'redux-notifications';
import { LoginFinished } from 'containers/AccessControl/Login/LoginFinished';
import { isRestrictedModeQuery } from 'redux/modules/shop/helpers';
import { setRestrictedMode } from 'redux/modules/restrictedmode';
import { browserHistory } from 'react-router';
import * as c from 'models/constants';

require('./style.scss');
require('containers/Html/style.css');

interface IProps {
	cart?: ICart;
	children: any;
	preloader: IPreloader;
	languageDomainValues?: ILanguage[];
	t?: (key: string) => string;
	clearShoppingBasket: (wishlist: boolean) => ICartAction;
	closeIdNotification: (id: string) => any;
	location?: Location;
	restrictedMode?: boolean;
	setRestrictedMode?: (a: boolean) => void;
}

interface IState {
	loaderTransition: boolean;
}

@connect(
	(state: IStore) => ({
		languageDomainValues: state.domainValues.languages,
		preloader: state.preloader,
		cart: state.cart,
		restrictedMode: state.restrictedMode.isRestrictedMode,
	}),
	(dispatch) => ({
		clearShoppingBasket: (wishlist: boolean) => dispatch(clearShoppingBasket(wishlist)),
		closeIdNotification: (id: string) => dispatch(notifActions.notifDismiss(id)),
		setRestrictedMode: (a) => dispatch(setRestrictedMode(a)),
	}),
)
@asyncConnect([
	{
		promise: ({ store: { dispatch } }) => {
			return dispatch(getLanguageDomainValues());
		},
	},
])
class App extends React.Component<IProps, IState> {
	private timer = null;

	constructor(props: IProps) {
		super(props);
		this.state = {
			loaderTransition: props.preloader.isVisible,
		};

		this.setShoppingBasketTimer = this.setShoppingBasketTimer.bind(this);
		this.removeShoppingBasketTimer = this.removeShoppingBasketTimer.bind(this);
		this.handleRestrictedMode = this.handleRestrictedMode.bind(this);
	}

	public handleRestrictedMode() {
		const restrictedModeQuery = isRestrictedModeQuery(this.props.location);
		if (!this.props.restrictedMode && restrictedModeQuery) {
			this.props.setRestrictedMode(!!restrictedModeQuery);
		}

		if (this.props.restrictedMode && !restrictedModeQuery) {
			try {
				const searchParams = new URL(this.props.location.href)?.searchParams;
				searchParams?.set(c.RESTRICTED_MODE, '1');
				const searchParamsStr = searchParams?.toString();
				let pathname = this.props.location.pathname;
				if (pathname[0] != '/') {
					pathname = '/' + pathname;
				}
				if (searchParamsStr) browserHistory.replace(`${pathname}?${searchParamsStr}`);
			} catch (e) {
				console.error(e);
			}
		}
	}

	private hideLoader() {
		if (!this.props.preloader.isVisible) {
			const preloader = document.getElementById('preloader');
			if (preloader) {
				this.setState({ loaderTransition: true });
				preloader.className = preloader.className + ' transition';
				setTimeout(() => {
					this.setState({ loaderTransition: false });
				}, 3000);
			}
		}
	}

	public componentDidMount() {
		this.setShoppingBasketTimer();
		this.handleRestrictedMode();
	}

	public componentDidUpdate(prev: IProps) {
		if (prev.location.pathname != this.props.location.pathname || prev.location.search != this.props.location.search) {
			this.handleRestrictedMode();
		}

		if (prev.preloader.isVisible) {
			this.hideLoader();
		}

		if (this.props.cart.shoppingBasket && prev.cart.shoppingBasket) {
			if (this.props.cart.shoppingBasket.itemsCount > prev.cart.shoppingBasket.itemsCount) {
				setShoppingBasketExpiryDate();
				this.setShoppingBasketTimer();
			} else if (this.props.cart.shoppingBasket.itemsCount < prev.cart.shoppingBasket.itemsCount) {
				if (this.props.cart.shoppingBasket.itemsCount === 0) {
					removeShoppingBasketExpiryDate();
					this.removeShoppingBasketTimer();
				} else {
					setShoppingBasketExpiryDate();
					this.setShoppingBasketTimer();
				}
			}
		}
	}

	public componentWillUnmount() {
		this.removeShoppingBasketTimer();
	}

	private setShoppingBasketTimer() {
		const shoppingBasketExpiryDate: Date = getShoppingBasketExpiryDate();
		if (shoppingBasketExpiryDate) {
			const dateTimeNow = new Date();
			let diff = (shoppingBasketExpiryDate.getTime() - dateTimeNow.getTime()) / 1000;
			diff /= 60;
			if (diff < 0) {
				this.props.clearShoppingBasket(true);
				removeShoppingBasketExpiryDate();
			} else {
				const diffMins = Math.abs(Math.ceil(diff));
				this.timer = setTimeout(
					() => {
						this.props.clearShoppingBasket(true);
						clearTimeout(this.timer);
					},
					1000 * 60 * diffMins,
				);
			}
		}
	}

	private removeShoppingBasketTimer() {
		clearTimeout(this.timer);
	}

	private closeNotification(id) {
		this.props.closeIdNotification(id);
	}

	public render() {
		const { children, preloader } = this.props;

		return (
			<section className="AppContainer">
				{!preloader.isVisible && !this.state.loaderTransition && (
					<style
						dangerouslySetInnerHTML={{
							__html: `
            ${
							detectIncompatibleBrowsers()
								? `
              html, body {
                height: 100%;
                overflow: auto;
              }`
								: ``
						}
            body {
              overflow-y: scroll;
            }
            .preloaderBody {
              display: none;
            }        
          `,
						}}
					/>
				)}
				<Notifs actionLabel="x" onActionClick={(el) => this.closeNotification(el)} />
				<Helmet {...appConfig.app} {...appConfig.app.head}>
					{/* inline script elements */}
				</Helmet>
				<LoginFinished {...this.props} />
				{children}
				<ModalManager />
			</section>
		);
	}
}

export { App };
